import apiClient from '../api/apiClient'
import type {
  CreateExperienceRequest,
  ExperienceResponse,
  ExperienceListResponse,
  UserExperience,
} from '../types/api'

export class ExperienceService {
  async createExperience(
    userId: string | number,
    experienceData: CreateExperienceRequest
  ): Promise<ExperienceResponse> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.post<ExperienceResponse>(
      `/admin/users/${encodedUserId}/experience`,
      experienceData,
    );
    return data;
  }

  async getExperiences(userId: string | number): Promise<ExperienceListResponse> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.get<ExperienceListResponse>(
      `/admin/users/${encodedUserId}/experience`,
    );
    return data;
  }

  async getExperience(userId: string | number, experienceId: number): Promise<{ experience: UserExperience }> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.get<{ experience: UserExperience }>(
      `/admin/users/${encodedUserId}/experience/${experienceId}`,
    );
    return data;
  }

  async updateExperience(
    userId: string | number,
    experienceId: number,
    experienceData: CreateExperienceRequest
  ): Promise<ExperienceResponse> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.put<ExperienceResponse>(
      `/admin/users/${encodedUserId}/experience/${experienceId}`,
      experienceData,
    );
    return data;
  }

  async deleteExperience(userId: string | number, experienceId: number): Promise<ExperienceResponse> {
    const encodedUserId = encodeURIComponent(String(userId));
    const { data } = await apiClient.delete<ExperienceResponse>(
      `/admin/users/${encodedUserId}/experience/${experienceId}`,
    );
    return data;
  }
}

export const experienceService = new ExperienceService();
